import React, { forwardRef, useImperativeHandle } from 'react';
import classNames from 'classnames';
import SideDrawer from 'router/subrouters/DataRoom/components/SideDrawer';
import {
  SideDrawerProps,
  SideDrawerRef,
} from 'router/subrouters/DataRoom/components/SideDrawer/SideDrawer.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { useTranslation } from 'react-i18next';
import { PausedSuggestedAction } from 'router/subrouters/DataRoom/models/Dashboard';
import MutedSuggestionActionItem from '../MutedSuggestionActionItem';
import BellOfIcon from 'icons/BellOf.icon';
import { getIsArrayEmpty } from 'utils';

import './MutedSuggestionsDrawer.styles.scss';

type MutedSuggestionsDrawerProps = {
  className?: string;
  pausedSuggestions: PausedSuggestedAction[];
} & SideDrawerProps;

const MutedSuggestionsDrawer: React.ForwardRefRenderFunction<
  SideDrawerRef,
  MutedSuggestionsDrawerProps
> = (props, ref) => {
  const { className, pausedSuggestions, ...rest } = props;

  const [drawer, drawerRef] = useCallbackRef<SideDrawerRef>(null);

  useImperativeHandle(ref, () => drawer, [drawer]);

  const classes = classNames('muted-suggestions-drawer', className);

  const { t } = useTranslation();

  const isEmptyPausedActions = getIsArrayEmpty(pausedSuggestions);

  return (
    <SideDrawer ref={drawerRef} className={classes} {...rest}>
      <p className="drawer-title">
        <BellOfIcon />
        {t('mutedSuggestions')}
      </p>
      <p className="muted-suggestions-drawer__description">
        {t('mutedSuggestionsDescription')}
      </p>

      {isEmptyPausedActions ? (
        <div className="muted-suggestions-drawer__empty">
          <div>
            <span>
              <BellOfIcon />
            </span>
            {t('noMutedSuggestions')}
          </div>
          <p>{t('noMutedSuggestionsDescription')}</p>
        </div>
      ) : (
        <div className="muted-suggestions-drawer__suggestions">
          {pausedSuggestions.map((pausedSuggestion) => (
            <MutedSuggestionActionItem
              key={pausedSuggestion.type}
              pausedSuggestion={pausedSuggestion}
            />
          ))}
        </div>
      )}
    </SideDrawer>
  );
};

export default forwardRef(MutedSuggestionsDrawer);
